export enum NotificationTemplateListColumns {
  NAME = 'Name',
  IS_GROUP_LEVEL = 'Group Level',
  SCHOOL_GROUP = 'School Group',
  SCHOOL = 'School',
  BODY_TYPE = 'Body Type',
  ACTIONS = 'Actions'
}
